// extracted by mini-css-extract-plugin
export default {"advertising-options":"AdvertisingOptions_advertising-options__h8yUH"};